import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const HomeIcon = (props: SvgProps) => (
  <Svg
    width={17}
    height={19}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      d="M8.891 1.3a1 1 0 0 0-1.46.034l-6.177 6.92A1 1 0 0 0 1 8.918v7.619a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V8.946a1 1 0 0 0-.287-.7L8.891 1.3Z"
    />
  </Svg>
)
export default HomeIcon
